import CreateCompany from '../Company/CreateCompany'

export default function CreateAccount() {
  return <CreateCompany />
}
